import { defineComponent as _defineComponent } from 'vue'
import { useChatProvider } from '~/composables/useChat';
import { IChannel } from '~/types/chat';
import Channel from './Channel.vue';

// gross but this is workaround for a bug with importing types/interfaces for defineProps
// @see https://github.com/vuejs/core/issues/4294

export default /*#__PURE__*/_defineComponent({
  __name: 'Chat',
  props: {
    channel: null,
    description: null,
    group: null,
    enableMessaging: { type: Boolean },
    title: null
  },
  setup(__props: any) {

const props = __props as {
  channel: IChannel['channel'];
  description?: IChannel['description'];
  group?: IChannel['group'];
  enableMessaging?: boolean;
  title: IChannel['title'];
};



useChatProvider(props);

return { __sfc: true,props, Channel }
}

})